<script>
import visibilityGroupItem from './visibility-group-item'

export default {
  name: 'visibilityGroupList',
  components: {
    visibilityGroupItem
  },
  computed: {
    visibilityoptionsgroup () {
      const state = this.$store.getters['visibilityGroupList/getState']
      return state.visibilityoptionsgroup
    }
  }
}
</script>

<template>
<div>
  <md-list-item v-for="group in visibilityoptionsgroup" :key="group.id">
    <visibilityGroupItem v-bind:title="group.title" v-bind:options="group.options" v-bind:group="group"/>
  </md-list-item>
</div>
</template>

<style lang="scss" scoped>
</style>
